import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Modal,Segment, TextArea, Message} from 'semantic-ui-react';
import { uploadAdditionalSummaryDetails } from '../../data/report_api';
import Loader from "../universal/loader";
import ReportContainer from "../../containers/report_container";
import { DropzoneComponent } from 'react-dropzone-component';
import * as unavailable from "../../assets/photo_unavailable.jpg";
import {uploadAdditionalImage,getAdditionalInspectionImages,deleteAdditionalImage} from "../../data/inspection_api";
const uuidv1 = require('uuid/v1');

class AdditionalSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAdditionalSummarySection: false,
            tenant_cost_summary:undefined,
            wear_and_tear_summary:undefined,
            landlord_items_summary:undefined,
            isSaving:false,
            errorMsg:undefined,
            loading:true,
            attachments:[]
        }
    }


    getAdditionalImages = async () => {
            const response = await getAdditionalInspectionImages(this.props.reportDetails.inspection_id)
            this.setState({ additional_images: response,loading:false })
        
    }


    updateAdditionalSummary = async  () =>{
             this.setState({isSaving:true,errorMsg:undefined})
        let formDataDict = {
            tenant_cost_summary: this.state.tenant_cost_summary,
            landlord_items_summary:this.state.landlord_items_summary,
            wear_and_tear_summary:this.state.wear_and_tear_summary
        }
        let formData = {}
        formData.report_id = this.props.reportDetails.id
        formData.additional_summary_details = JSON.stringify(formDataDict)
        uploadAdditionalSummaryDetails(formData).then(async (response)=>{
            if(response.success){
                if(this.state.attachments) {
                    let addResponse = undefined
                    for (let i = 0; i < this.state.attachments.length; i++) {
                        if (this.state.attachments[i].status === "queued") {
                        const formData = new FormData();
                        formData.append("id", this.state.attachments[i].upload.uuid);
                        formData.append("file", this.state.attachments[i]);
                        formData.append("inspection_id",this.props.reportDetails.inspection_id);
                        formData.append("image_type","tenant_cost");
                        addResponse = await uploadAdditionalImage(formData);
                    }
                        
                    }
                }
                this.props.updateAdditionalSummaryDetailsInReport(formDataDict)
                this.completeFn()
            } else {
                    this.setState({errorMsg:response.statusMessage || "There was an error while saving, please try again",isSaving:false})}
        }).catch((e) => {
            {this.setState({errorMsg:"There was an error while saving, please try again",isSaving:false})}
        });
    }

    completeFn = () => {
       // this.props.resetDataQueuedInAPI('disclaimers');
        this.setState({isSaving: false});
        this.props.handleClose();
    };

        exitWindow = () =>{
        this.props.resetDataQueuedInAPI('summary');
        this.setState({isSaving:false});
        this.props.handleClose();
    }
    componentWillMount() {
        this.setState({showAdditionalSummarySection: this.props.showAdditionalSummary});
        if (this.props.reportDetails.additional_summary_detail){
            this.setState({...this.props.reportDetails.additional_summary_detail})
        }
        this.getAdditionalImages()
    }

      preloadImages = (dropzone,imageData) => {
            if (imageData) {
    
                for (let i = 0; i < imageData.length; i++){
                    if(imageData[i].image_type == "tenant_cost"){
                const name = imageData[i].id
                const file = {url: imageData[i].file?imageData[i].file:unavailable, name: name, size: 1000000, id: name};
                const imageUrl = imageData[i].file;
    
                file['serverId'] = name;
                file['accepted'] = true;
                file['status'] = 'success';
                file['upload'] = {
                    progress: 100,
                    total: 100000,
                    bytesSent: 100000
                };
                dropzone.files.push(file);
                this.state.attachments.push(file)
                this.setState({preLoaded:true});
                dropzone.emit("addedfile", file);
                dropzone.emit("thumbnail", file, imageUrl);
                    dropzone.emit("complete", file);
                }
            }
            }
        };
    
        removingFile = (file) => {
            let attachments = this.state.attachments;
            if (attachments.indexOf(file) !== -1) {
                attachments.splice(attachments.indexOf(file), 1);
            }
            if (file.id) { deleteAdditionalImage({image_id:file.id}) }
            return attachments;
        };

    render() {

         let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpeg, image/png, image/gif",
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone, this.state.additional_images);
            },
            addedfile: (file) => {
                if(file.type.startsWith("image/")){
                  this.setState({attachments:[...this.state.attachments,file]})
                    this.setState({imageError:false})
                }
                else {
                    this.setState({imageError:true})
                }
            },

            removedfile: (file) => {
                this.removingFile(file)                   
            }
        };
        
        const additionalSummary = {};
        return (<Segment>
            {this.state.isSaving && <Loader save={true}/>}
            <Modal size="small" open={this.state.showAdditionalSummarySection} onClose={(e) => {
                this.updateAdditionalSummary();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll'}}>
                    <Header floated="right"><Icon className="icon-button" name="save" onClick={(e) => {
                        this.updateAdditionalSummary();
                    }}/></Header>
                    <Modal.Description>
                        <Header as='h2' textAlign='center'>
                            Summary Additional Notes
                        </Header>
                          {this.state.errorMsg && <Message>There was an error while saving additional summary details, please try again.   {this.state.errorMsg} <hr/>  <Button compact onClick={(e) => {
                        this.updateAdditionalSummary();
                    }}>Retry Save</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        <Segment>
                            <Form>
                                <Segment>
                                <Header size="small">Tenant Cost General Note</Header>
                                <TextArea style={{verticalAlign: 'middle'}}
                                          value={this.state.tenant_cost_summary}
                                          placeholder="Tenant cost General Note"
                                          autoFocus fluid rows={3}
                                          onFocus={(e) => {
                                              this.setState({tenant_cost_summary: e.target.value})
                                          }}
                                          onChange={(e) => {
                                              this.setState({tenant_cost_summary: e.target.value})
                                          }}
                                          required
                                />
{!this.state.loading && <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                                                eventHandlers={eventHandlers} djsConfig={djsConfig}/>}
                                                </Segment>
                                <Header size="small">Wear and Tear General Note</Header>
                                <TextArea style={{verticalAlign: 'middle'}}
                                          defaultValue={this.state.wear_and_tear_summary}
                                          placeholder="Wear and Tear General Note"
                                          autoFocus fluid rows={3}
                                          onFocus={(e) => {
                                              this.setState({wear_and_tear_summary: e.target.value})
                                          }}
                                          onChange={(e) => {
                                              this.setState({wear_and_tear_summary: e.target.value})
                                          }}
                                          required
                                />
                                <Header size="small">Landlord Info General Note</Header>
                                <TextArea style={{verticalAlign: 'middle'}}
                                          defaultValue={this.state.landlord_items_summary}
                                          placeholder="Landlord Info General Note"
                                          autoFocus fluid rows={3}
                                          onFocus={(e) => {
                                              this.setState({landlord_items_summary: e.target.value})
                                          }}
                                          onChange={(e) => {
                                              this.setState({landlord_items_summary: e.target.value})
                                          }}
                                          required
                                />
                            </Form>
                        </Segment>
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }
}

export default ReportContainer(AdditionalSummary);


// WEBPACK FOOTER //
// ./src/views/report/additional_summary_notes.js